<template>
  <v-container class="container--fluid fill-height primary">
    <v-row
      no-gutters
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="9"
        md="6"
        lg="3"
      >
        <v-card class="elevation-5 pa-3">
          <v-card-text class="d-flex justify-center">
            <v-avatar
              size="100px"
              tile
            >
              <img
                src="@/assets/logo.svg"
                alt="logo"
              >
            </v-avatar>
          </v-card-text>
          <v-card-text>
            <v-form
              ref="loginForm"
              v-model="valid"
              lazy-validation
              @submit.prevent="login"
              data-cy="loginForm"
            >
              <v-text-field
                type="email"
                name="email"
                v-model="loginData.email"
                :label="$t('login.email')"
                append-icon="email"
                :rules="validationRules.emailRules"
                data-cy="emailField"
              />
              <v-text-field
                :type="visiblePassword ? 'text' : 'password'"
                name="password"
                v-model="loginData.password"
                :label="$t('login.password')"
                :append-icon="visiblePassword ? 'visibility' : 'visibility_off'"
                :rules="validationRules.passwordRules"
                @click:append="togglePasswordVisibility"
                data-cy="passwordField"
              />
              <v-btn
                type="submit"
                color="success"
                class="mt-4"
                large
                data-cy="loginSubmitBtn"
              >
                {{ $t('login.singIn') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import * as actions from '@/store/actions.type';
  import * as routeConstants from '@/router/constants';
  import { NOTIFICATION_ERROR } from '@/common/event.types';
  import {mapActions} from 'vuex';

  export default {
    name: 'Login',
    data: () => ({
      loginData: {
        email: '',
        password: '',
      },
      valid: true,
      visiblePassword: false,
    }),
    computed: {
      validationRules() {
        return {
          emailRules: [
            v => !!v || this.$t('validationMessages.login.email.required'),
            v => /.+@.+\..+/.test(v) || this.$t('validationMessages.login.email.valid'),
          ],
          passwordRules: [
            v => !!v || this.$t('validationMessages.login.password.required'),
            v => (v.length > 6) || this.$t('validationMessages.login.password.minLength', {minLength: 6}),
          ],
        };
      },
    },
    methods: {
      ...mapActions({
        loginAction: actions.LOGIN,
      }),
      login() {
        if (this.$refs.loginForm.validate()) {
          this.loginAction(this.loginData).then(() => {
            this.$router.push(routeConstants.DASHBOARD_URL);
          }).catch(({data}) => {
            this.$eventHub.$emit(NOTIFICATION_ERROR, {
              message: data,
            });
          });
        }
      },
      togglePasswordVisibility() {
        this.visiblePassword = !this.visiblePassword;
      },
    },
  };
</script>

<style scoped>

</style>